const folderDefaultState = {
  folders: [],
  folderDepth: null,
  breadcrumbsMultipleLevelsArray: [], // for general use later, pls move this state somewhere else
  currentFolderDepth: 0,
}

export default folderDefaultState
